import { fork } from "redux-saga/effects";
import type { Saga } from "redux-saga";
import { userSagas } from "./user";

export default function* rootSagas(): Saga<any> {
  yield fork(userSagas);
}
